import {STAMP_4S_PRODUCT_ID, STAMP_SIGN_LANGUAGE_PRODUCT_ID} from "../../util/Constants"
import {fetchStampFamilyData, fetchStampSignLanguageData, ReportProps} from "./ReportData"
import {ReportFilters} from "../reports/common/models/ReportFilters"
import StampReportHeader from "./components/StampReportHeader"
import {TestControlsContainer, TestControlsContainerProps} from "../reports/class/components/TestControls"
import TestTakerTableContainer from "./components/testTakerSortableTable/TestTakerTableContainer"
import {SkillColumnData} from "./components/testTakerSortableTable/Columns"
import SummaryCharts from "./components/summaryCharts/SummaryCharts"
import {PanelSkillEnum} from "../../types/types"

export interface ReportStructure {
    data?: (filters: ReportFilters) => void
    Header: (props: ReportProps) => JSX.Element
    SummaryCharts?: (props: ReportProps) => JSX.Element
    TestControls?: (props: TestControlsContainerProps) => JSX.Element
    TestInstancesList: (props: ReportProps) => JSX.Element | null
    TestInstancesListColumns?: SkillColumnData[]
}

const STAMPFamilyReportStructure: ReportStructure = {
    Header: StampReportHeader,
    SummaryCharts: SummaryCharts,
    TestControls: TestControlsContainer,
    TestInstancesList: TestTakerTableContainer,
}

const STAMP4SReportStructure: ReportStructure = {
    ...STAMPFamilyReportStructure,
    data: fetchStampFamilyData,
    TestInstancesListColumns: [
        {
            title: "Reading",
            key: "readingScore",
            centerContent: true,
            symbol: PanelSkillEnum.READING,
        },
        {
            title: "Reading Scaled Score",
            key: "readingScore",
            scaledScoreKey: "readingScaledScore",
            centerContent: true,
        },
        {
            title: "Writing",
            key: "writingScore",
            centerContent: true,
            symbol: PanelSkillEnum.WRITING,
        },
        {
            title: "Listening",
            key: "listeningScore",
            centerContent: true,
            symbol: PanelSkillEnum.LISTENING,
        },
        {
            title: "Listening Scaled Score",
            key: "listeningScore",
            scaledScoreKey: "listeningScaledScore",
            centerContent: true,
        },
        {
            title: "Speaking",
            key: "speakingScore",
            centerContent: true,
            symbol: PanelSkillEnum.SPEAKING,
        },
    ],
}

const STAMPSignLanguageStructure: ReportStructure = {
    ...STAMPFamilyReportStructure,
    data: fetchStampSignLanguageData,
    TestInstancesListColumns: [
        {
            title: "Receptive",
            key: "listeningScore",
            centerContent: true,
            symbol: PanelSkillEnum.RECEPTIVE,
        },
        {
            title: "Receptive Scaled Score",
            key: "listeningScore",
            scaledScoreKey: "listeningScaledScore",
            centerContent: true,
        },
        {
            title: "Expressive",
            key: "speakingScore",
            centerContent: true,
            symbol: PanelSkillEnum.EXPRESSIVE,
        },
    ],
}

export const ReportStructuresMap: Map<number, ReportStructure> = new Map([
    [STAMP_4S_PRODUCT_ID.value(), STAMP4SReportStructure],
    [STAMP_SIGN_LANGUAGE_PRODUCT_ID.value(), STAMPSignLanguageStructure],
])
